module.exports = __webpack_public_path__ + "img/avatar_bmad.856de8e5.jpg";